import { lazy } from 'react'
import DeleteIcon from '@nv/images/design/delete-icon'
import DownloadFileIcon from '@nv/images/design/download-file-icon'
import ViewIcon from '@nv/images/design/view-icon'
import { AdminVoterAuthService } from '@nv/services'
import { getFileType } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import { ActionDropdown } from '../action_dropdown/ActionDropdown'
import FileIcon from '../file_icon/FileIcon'
import useNVModal from '../modal_master/nv_modal/useNVModal'
import styles from './DocCard.module.scss'
const ConfirmDeleteFile = lazy(() => import('@nv/lazy-loadable/lib/modals/ConfirmDeleteFile'))
const FileViewer = lazy(() => import('@nv/lazy-loadable/lib/modals/FileViewer'))

const DocCard = ({ doc, getDocs, index, viewOnly }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const { NVModal: ConfirmDeleteFileModal, openModal: openConfirmDeleteFileModal, closeModal: closeConfirmDeleteFileModal } = useNVModal()
  const { NVModal: FileViewerModal, openModal: openFileViewerModal } = useNVModal()

  if (!doc.filename || !doc.filename[currentLanguage] || !doc.title || !doc.title[currentLanguage]) return null
  const fileType = getFileType(doc.filename[currentLanguage])

  const deleteFile = async () => {
    try {
      await AdminVoterAuthService.deleteHelpDoc(doc.id)
      getDocs()
      closeConfirmDeleteFileModal()
    } catch (error) {
      // Handle error
    }
  }

  const downloadFile = async () => {
    try {
      const url = doc.fileUrl[currentLanguage]
      const response = await fetch(url)

      if (!response.ok) {
        console.error('Failed to fetch the file')
      }

      const blob = await response.blob()

      const alink = document.createElement('a')
      alink.href = window.URL.createObjectURL(blob)
      alink.download = `${doc.filename[currentLanguage]}`
      document.body.appendChild(alink)
      alink.click()
      document.body.removeChild(alink)
    } catch (error) {
      // Handle error
    }
  }

  const actionData = [
    {
      value: 'View',
      label: t('main.view'),
      callback:
        fileType === 'pdf' ? () => window.open(doc.fileUrl[currentLanguage], '_blank', 'noopener,noreferrer') : () => openFileViewerModal(),
      icon: <ViewIcon color='var(--svg-darker-fill)' />,
    },
    {
      value: 'Download',
      label: t('buttons.download'),
      callback: downloadFile,
      icon: <DownloadFileIcon color='var(--svg-darker-fill)' />,
    },
  ]
  if (!viewOnly) {
    actionData.push({
      value: 'Delete',
      label: t('buttons.delete'),
      callback: () => openConfirmDeleteFileModal(),
      icon: <DeleteIcon color='var(--svg-darker-fill)' />,
    })
  }

  return (
    <>
      <ConfirmDeleteFileModal>
        <ConfirmDeleteFile onDelete={() => deleteFile()} />
      </ConfirmDeleteFileModal>

      <FileViewerModal>
        <FileViewer file={doc} />
      </FileViewerModal>

      <div className={styles['container']} key={index}>
        <div className={styles['body']}>
          <span className={styles['body__txt']}>{doc.title[currentLanguage]}</span>
        </div>
        <div className={styles['footer']}>
          <FileIcon filename={doc.filename} />
          <ActionDropdown values={actionData} fileName={doc.filename[currentLanguage]} />
        </div>
      </div>
    </>
  )
}

export default DocCard
